
import { Component, Vue } from 'vue-property-decorator';
import TopNavbar from '../components/navigation/TopNavbar.vue';
import GeneralMenu from '../components/navigation/GeneralMenu.vue';

@Component({
    components: {
        TopNavbar,
        GeneralMenu,
    },
})
export default class AnonymousRoot extends Vue {
    created() {
        this.$store.state.appLoaded = true;
    }
}
